import CompatsWidgetSticky from '../../../../../pages/vip/features/compats-widget-sticky/compats-widget-sticky.mobile';

export default CompatsWidgetSticky;
